"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.role = exports.Role = void 0;
const schema_1 = require("../schema");
var Role;
(function (Role) {
    Role["MedicalPractitioner"] = "ROLE_MEDICAL_PRACTITIONER";
    Role["DecisionMaker"] = "ROLE_DECISION_MAKER";
    Role["Reviewer"] = "ROLE_REVIEWER";
    Role["SuperUser"] = "ROLE_ADMIN";
})(Role || (exports.Role = Role = {}));
exports.role = schema_1.Schema.enum([
    Role.MedicalPractitioner,
    Role.DecisionMaker,
    Role.Reviewer,
    Role.SuperUser
]);
